<template>
    <div v-if="showCalculator !== 'hide'">
        <div v-if="calculatorPending">
            <p class="text">Загрузка...</p>
        </div>
        <section id="mortgage-calc">
            <div>
                <div class="mortgage-calculator-new" v-show="!calculatorPending && calculatorReady">
                    <div class="mortgage-calculator-new__left">
                        <div class="h2" v-if="singleProgram">Рассчитайте ипотеку на выгодных условиях</div> <!-- Product page only -->
                        <div class="h3 _mt-32" v-if="singleProgram">Параметры кредита</div> <!-- Product page only -->
                        <div class="mortgage-calculator-new__subtitle" v-else>Ипотечные программы</div>
                        <div class="_mt-16" v-if="!singleProgram">
                            <div class="mortgage-calculator-new__tags">
                                <div v-for="(tag, idx) in tags"
                                    :key="idx"
                                    @click.prevent="changeProgram(tag.code)"
                                    :class="{'mortgage-calculator-new__tag_active': targetProgram === tag.code}"
                                    class="mortgage-calculator-new__tag _mb-16-0"
                                >
                                    <span v-html="tag.title"></span>
                                </div>
                            </div>
                        </div>
                        <div class="_mt-32" v-if="izsRate.length && targetProgram === 'product_building_house'">
                            <div class="checkbox" @click="changeIzs">
                                <input v-model="izs" type="checkbox" class="checkbox__input">
                                <div class="checkbox__label">
                                    <p class="text-small gray-text-ninth">С использованием эскроу-счёта скидка {{ izsRate }}% к ставке</p>
                                </div>
                            </div>
                        </div>
                        <div class="_mt-24">
                            <div class="noUi noui_pb">
                                <div class="noUi__input">
                                    <input type="text" v-model.lazy="realty" ref="realtyInput" inputmode="numeric" v-mask-numeric v-money class="noUi__text" :disabled="calculatorError">
                                    <label class="form__label">Стоимость недвижимости</label>
                                    <div ref="mortgagePrice" :disabled="calculatorError"></div>
                                </div>
                                <span class="noUi__start noUi_blur"> {{ realtyPeriods.stgMin | sliderValues  }} </span>
                                <span class="noUi__middle noUi__middle_ml-47 noUi_blur"> {{ realtyPeriods.stgMiddle | sliderValues  }} </span>
                                <span class="noUi__end noUi_blur"> {{ realtyPeriods.stgMax | sliderValues  }} </span>
                            </div>
                        </div>
                        <div class="_mt-32" v-if="targetProgram !== 'product_refinancing'">
                            <div class="noUi noui_pb">
                                <div class="noUi__input">
                                    <input type="text" v-model.lazy="pledge" ref="pledgeInput" inputmode="numeric" v-mask-numeric v-money class="noUi__text" :disabled="calculatorError">
                                    <label class="form__label">Первоначальный взнос</label>
                                    <div ref="pledge" :disabled="calculatorError || sliderDisabledPrv"></div>
                                    <div class="mortgage-calculator-new__val">{{ prvPercent }}%</div>
                                </div>
                                <span class="noUi__start noUi_blur"> {{ pledgePeriods.pledgeMin | sliderValues  }} </span>
                                <span class="noUi__middle noUi__middle_ml-47 noUi_blur"> {{ pledgePeriods.pledgeMiddle | sliderValues  }} </span>
                                <span class="noUi__end noUi_blur"> {{ pledgePeriods.pledgeMax | sliderValues  }} </span>
                            </div>
                            <p class="p2 gray-text-light _mt-16" v-if="sliderDisabledPrv">Для выбранной стоимости недвижимости нельзя изменить размер первоначального взноса</p>
                        </div>
                        <div class="_mt-32" v-else>
                            <div class="noUi noui_pb">
                                <div class="noUi__input">
                                    <input type="text" v-model.lazy="remainingDebt" ref="remainingInput" inputmode="numeric" v-mask-numeric v-money class="noUi__text" :disabled="calculatorError">
                                    <label class="form__label">Остаток долга по ипотеке</label>
                                    <div ref="remaining" :disabled="calculatorError"></div>
                                    <div class="mortgage-calculator-new__val">{{ remainingDebtPercent }}%</div>
                                </div>
                                <span class="noUi__start noUi_blur"> {{ remainingDebtPeriods.remainingMin | sliderValues  }} </span>
                                <span class="noUi__middle noUi__middle_ml-47 noUi_blur"> {{ remainingDebtPeriods.remainingMiddle | sliderValues  }} </span>
                                <span class="noUi__end noUi_blur"> {{ remainingDebtPeriods.remainingMax | sliderValues  }} </span>
                            </div>
                        </div>
                        <div class="_mt-32">
                            <div class="noUi noui_pb">
                                <div class="noUi__input">
                                    <input type="text" v-model.lazy="period" ref="periodInput" inputmode="numeric" v-mask-numeric class="noUi__text" :disabled="calculatorError">
                                    <label class="form__label">Желаемый срок кредита</label>
                                    <div ref="period" :disabled="calculatorError"></div>
                                    <div class="mortgage-calculator-new__val _mobile-hidden">{{ years }}</div>
                                </div>
                                <span class="noUi__start noUi_blur"> {{ periods.periodMin | withFullMonths }} </span>
                                <span class="noUi__middle noUi__middle_ml-40 noUi_blur"> {{ periods.periodMiddle | withMonths }} </span>
                                <span class="noUi__end noUi_blur"> {{ periods.periodMax | withMonths }} </span>
                            </div>
                        </div>
                    </div>
                    <div class="mortgage-calculator-new__right" v-if="!calculatorError">
                        <div class="mortgage-calculator-new__right-mobilewrapper">
                            <div class="mortgage-calculator-new__right-header _justify-content-between">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Платёж в месяц</p>
                                <p class="mortgage-calculator-new__right-title">{{ monthlyPay | formatMoneyToInt }}</p>
                            </div>
                            <div class="_dflex _justify-content-between _align-items-center _mt-16">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Диапазон полной стоимости кредита <hint no-margin text="Сумма ваших реальных расходов по кредиту в период его действия, включая платежи по погашению основной суммы долга, уплаты процентов, страховой премии и иных расходов, следующих из договора" /></p>
                                <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min mortgage-calculator-new__right-title_range _mt-8">{{ range }}</p>
                            </div>
                            <div class="_dflex _justify-content-between _align-items-center _mt-16">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Ставка</p>
                                <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ rate | formatPercent }}</p>
                            </div>
                            <div class="_dflex _justify-content-between _align-items-center _mt-16">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Сумма кредита</p>
                                <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ loanAmount | formatMoneyToInt }}</p>
                            </div>
                            <div class="_dflex _justify-content-between _align-items-center _mt-16">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Срок кредита</p>
                                <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ years }}</p>
                            </div>
                            <div class="_dflex _justify-content-between _align-items-center _mt-16">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Необходимый доход</p>
                                <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ income | formatMoneyToInt }}</p>
                            </div>
                            <div class="_dflex _justify-content-between _align-items-center _mt-16">
                                <p class="mortgage-calculator-new__right-par gray-text-light">Налоговый вычет <hint no-margin :text="taxDeductionText" /></p>
                                <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ taxDeduction | formatMoneyToInt }}</p>
                            </div>
                        </div>
                        <div class="_mt-24">
                            <mortgage-send-with-lk button-text="Подать заявку" :calculator-data="{initialPayment: pledge, creditAmount: loanAmount, creditPeriod: period}" :program-code="program" additional-classes="_dflex _justify-content-center _w-100"></mortgage-send-with-lk>
                            <DButton
                                v-if="singleProgram"
                                class="_dflex _justify-content-center _w-100 _mt-16"
                                :color="EColor.GREY"
                                @click="$modal.show('paymentsShedule')"
                            >
                                График платежей
                            </DButton>
                        </div>
                        <div class="_mt-24">
                            <p class="p4" v-if="singleProgram">*Предложение носит информационный характер и не является публичной офертой. Расчет суммы кредита осуществлен для Москвы/Московской области. Итоговые параметры кредита определяются при заключении договора</p>
                            <p class="p4" v-else v-html="targetText"></p>
                        </div>
                    </div>
                    <div class="mortgage-calculator-new__right mortgage-calculator-new__right_min" v-else>
                        <div class="_dflex _flexwrap">
                            <div class="_dflex _align-items-start">
                                <img src="/local/templates/redesign/src/assets/img/mortgage/alert.svg" class="_mr-17" />
                                <div class="mortgage-calculator-new__right-works">
                                    <div class="h4">Проводятся плановые работы</div>
                                    <p class="p1 _mt-8">Ипотечный калькулятор недоступен</p>
                                </div>
                            </div>

                            <DButton
                                class="_dflex _justify-content-center _w-100 _mt-24"
                                :color="EColor.BLACK"
                                to="/mortgage/"
                                target="_blank"
                            >
                                Все программы
                            </DButton>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <mortgage-calculator-payments :calculator-data="{ targets:targetName, rate:rate, period:period, loanAmount:loanAmount, monthlyPay: monthlyPay }" />
    </div>
</template>

<script>
import axios from 'axios';
import noUiSlider from 'nouislider';
import filters, { formatMoneyToInt, formatPercent, } from '../../assets/js/vue/filters';
import { maskNumeric, money } from '../../assets/js/vue/directives';
import programs from './calculator/programs.json';
import Hint from '../../components/Hint.vue';
import MortgageSendWithLk from '../../components/mortgage/mortgageSendWithLk.vue';
import MortgageCalculatorPayments from './MortgageCalculatorPayments.vue';
import { DButton, EColor } from '@ahml/domrfbank-ui/elements/DButton';

const clone = (target) => JSON.parse(JSON.stringify(target));

export default {
    name: "MortgageCalculatorNew",
    directives: {
        maskNumeric,
        money,
    },
    props: {
        program: {
            type: String,
            default: ''
        },
        calculatorPrograms: {
            type: Array,
            default: () => {
                return []
            }
        },
        ranges: {
            type: Array,
            default: () => {
                return []
            }
        },
        izsRate: {
            type: String,
            default: "",
        },
        showCalculator: {
            type: String,
            default: 'show',
        },
        newRate: {
            type: Array,
            default: () => {
                return []
            }
        },
        izsEscrow: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Hint,
        MortgageSendWithLk,
        MortgageCalculatorPayments,
        DButton
    },
    data() {
        return {
            ...clone(programs),
            filters: filters,
            tags: [],
            singleProgram: true,
            targetName: '',
            targetProgram: '',
            targetText: '',
            calculatorReady: false,
            calculatorPending: true,
            realty: 5000000,
            pledge: 1500000,
            period: 180,
            prvPercent: 0,
            kz: 0,
            rate: 0,
            loanAmount: 0,
            monthlyPay: 0,
            income: 0,
            product: null,
            apix: null,
            taxDeductionRealty: null,
            taxDeductionPercents: null,
            taxDeduction: null,
            taxDeductionText: '',
            maxCreditAmount: 0,
            minCreditAmount: 500000,
            calculatorError: false,
            prvCalculatedPar: 5000000,
            prvMin: 500000,
            remainingDebt: 1500000,
            remainingDebtMax: 30000000,
            remainingDebtPercent: 0,
            sliderDisabledPrv: false,
            range: '',
            izs: false,
            EColor
        }
    },
    filters: {
        withFullMonths: (value) => {
            return `${value} месяцев`
        },
        withMonths: (value) => {
            return `${value} мес.`
        },
        months: (value) => {
            return value === 1 ? `${value} месяц` : [2, 3, 4].includes(value) ? `${value} месяца` : `${value} месяцев`
        },
        sliderValues: (value) => {
            if (value < 1000000) {
                return (value / 1000).toFixed(1).split('.')[1] === '0' ? `${Math.round(value / 1000)} тыс.` : `${(value / 1000).toFixed(1).replace('.', ',')} тыс.`
            }
            else {
                return (value / 1000000).toFixed(1).split('.')[1] === '0' ? `${Math.round(value / 1000000)} млн` : `${(value / 1000000).toFixed(1).replace('.', ',')} млн`
            }
        },
        formatMoneyToInt,
        formatPercent,
    },
    methods: {
        getApixResults() {
            let timeout = setTimeout(()=> {
                let sendData = {
                    data: {
                        type: "creditTermsByHousingCost",
                        attributes: {
                            creditPeriod: this.period,
                            housingValue: Math.round(this.realty),
                            interestPercent: this.rate
                        }
                    }
                };

                if (this.$props.program !== 'product_refinancing') {
                    sendData.data.attributes.initialPayment = Math.round(this.pledge);
                }
                else {
                    sendData.data.attributes.creditAmount = this.remainingDebt;
                }

                axios.post(`/rest/v1/mortgage/calculator/creditTermsByHousingCost?sessid=${window.config.bitrix_sessid}`, sendData, {headers: {'Accept': 'application/vnd.api+json'},  timeout: 5000})
                    .then((response) => {
                        if (response.status !== 200) {
                            this.calculatorError = true;
                        }
                        else {
                            this.loanAmount = this.$props.program !== 'product_refinancing' ? response.data.data.attributes.creditAmount : this.remainingDebt;
                            this.monthlyPay = response.data.data.attributes.monthlyPayment;
                            this.income = response.data.data.attributes.requiredMonthlyIncome;

                            if (response.data.data.attributes.creditAmount > this.maxCreditAmount) {
                                this.loanAmount = this.$props.program !== 'product_refinancing' ? this.maxCreditAmount : this.remainingDebt;
                            }
                            else if (response.data.data.attributes.creditAmount < this.minCreditAmount) {
                                this.loanAmount = this.$props.program !== 'product_refinancing' ? this.minCreditAmount : this.remainingDebt;
                            }
                        }
                    })
                    .catch(() => {
                        this.calculatorError = true;
                    })
                    .finally(() => {
                        clearTimeout(timeout);
                        this.taxDeductionCalculate();
                    })
            }, 100)
        },
        taxDeductionCalculate() {
            this.taxDeductionRealty = this.realty <= 2000000 ? Math.round(this.realty * 0.13) : 260000;
            let calcPercents = Math.round((this.monthlyPay * this.period) - this.loanAmount);
            this.taxDeductionPercents = calcPercents <= 3000000 ? Math.round(calcPercents * 0.13) : 390000;
            this.taxDeduction = this.taxDeductionRealty + this.taxDeductionPercents;
            this.taxDeductionText = `Сумма, которую вы можете вернуть в качестве налогового вычета после покупки жилья в ипотеку. Сумма налогового вычета складывается из: ${this.filters.formatMoneyToInt(this.taxDeductionRealty)} - 13% от стоимости недвижимости и ${this.filters.formatMoneyToInt(this.taxDeductionPercents)} - 13% от суммы уплаченных процентов. <br> <a target='_blank' class='link' href='https://domrfbank.ru/blog/nalogovyy-vychet-pri-pokupke-i-prodazhe-nedvizhimosti/'>Подробнее</a>`;
        },
        changeProgram(program) {
            this.izs = false;
            this.product = this.apix.filter(val => val.id === program);
            this.targetProgram = program;
            this.targetName = this.product[0].attributes.name;
            this.maxCreditAmount = this.product[0].attributes.product.maxCreditAmount[0].maxCreditAmount;
            this.getCalculationsFunctions();
            this.getTargetText();
            this.getRateRange();
        },
        changeIzs() {
            this.izs = !this.izs;
            this.getRate();
        },
        getTargetText() {
            if (this.$props.izsEscrow && this.targetProgram === 'product_building_house') {
                this.targetText = this.programsTexts.filter(val => val.code === 'product_building_house_escrow')[0].text;
            }
            else {
                this.programsTexts.forEach(el => {
                    if (el.code === this.targetProgram) {
                        this.targetText = el.text;
                    }
                })
            }
        },
        getCalculationsFunctions() {
            this.setInputsValues();
            this.getPrvPercent();
            this.getKZ();
            this.getRate();

            if (this.targetProgram === 'product_refinancing') {
                this.$nextTick(() => {
                    this.getRemainingDebtPercent();
                })
            }
        },
        getRemainingDebtPercent() {
            this.remainingDebtPercent = Math.round(this.remainingDebt / this.realty * 100);
        },
        setInputsValues() {
            if (this.$props.program !== 'product_refinancing') {
                if (this.realty >= this.prvCalculatedPar) {
                    this.pledgePeriods.pledgeMax = Math.round(this.realty * 0.9);
                }
                else if (this.realty < this.prvCalculatedPar) {
                    this.pledgePeriods.pledgeMax = this.realty - this.prvMin;
                }

                this.pledgePeriods.pledgeMin = this.realty - (this.realty * (this.product[0].attributes.product.parameters.maxDebtToPledge / 100));
                this.pledgePeriods.pledgeMiddle = (this.pledgePeriods.pledgeMin + this.pledgePeriods.pledgeMax) / 2;

                if (this.pledgeSlider) {
                    this.updatePrvSlider();
                }
            }
            else {
                this.remainingDebtPeriods.remainingMax = Math.round(this.realty * 0.85);
                this.remainingDebtPeriods.remainingMiddle = this.remainingDebtPeriods.remainingMax / 2;

                if (this.remainingDebtPeriods.remainingMax > this.remainingDebtMax) {
                    this.remainingDebtPeriods.remainingMax = this.remainingDebtMax;
                }

                this.$nextTick(() => {
                    this.remainingDebtSlider.updateOptions({
                        start: this.remainingDebt,
                        range: {
                            'min': this.remainingDebtPeriods.remainingMin,
                            'max': this.remainingDebtPeriods.remainingMax
                        }
                    });
                });
            }
        },
        updatePrvSlider() {
            if (this.pledge < this.pledgePeriods.pledgeMin) {
                 this.pledge = this.pledgePeriods.pledgeMin;
            }

            if (this.realty - this.pledge > this.maxCreditAmount) {
                this.$nextTick(() => {
                    this.pledge = Math.round(this.realty - this.maxCreditAmount);
                    this.pledgeSlider.set(this.pledge);
                    this.getPrvPercent();
                })
            }

            this.pledgeSlider.updateOptions({
                start: this.pledge,
                range: {
                    'min': this.pledgePeriods.pledgeMin,
                    'max': this.pledgePeriods.pledgeMax
                }
            });

            this.$nextTick(() => {
                this.getApixResults();
            })
        },
        getPrvPercent() {
            this.prvPercent = Math.round((this.pledge / this.realty) * 100);
        },
        getKZ() {
            return this.kz = this.program !== 'product_refinancing' ? Math.round((this.realty - this.pledge) / this.realty * 100) : Math.round(this.remainingDebt / this.realty * 100);
        },
        getRate() {
            let rateUpdated = 0;

            if (this.$props.newRate.length) {
                rateUpdated = this.$props.newRate[this.$props.calculatorPrograms.indexOf(this.targetProgram)];
            }

            if (rateUpdated && rateUpdated !== 'default') {
                this.rate = this.$props.newRate[this.$props.calculatorPrograms.indexOf(this.targetProgram)];
            }
            else {
                for (let i=0; i < this.product[0].attributes.product.interestAmount.length; i++) {
                    if (!this.product[0].attributes.product.interestAmount[i].minCreditToPledge && !this.product[0].attributes.product.interestAmount[i].maxCreditToPledge) {
                        this.rate = this.product[0].attributes.product.interestAmount[i].interestPercent;
                    }
                    else {
                        if ((this.kz >= this.product[0].attributes.product.interestAmount[i].minCreditToPledge && this.kz <= this.product[0].attributes.product.interestAmount[i].maxCreditToPledge)
                            || (this.kz >= this.product[0].attributes.product.interestAmount[i].minCreditToPledge && this.kz > this.product[0].attributes.product.interestAmount[i].maxCreditToPledge)) {
                            this.rate = this.product[0].attributes.product.interestAmount[i].interestPercent;
                        }
                    }
                }

                this.rate = this.izs ? this.rate - Number(this.$props.izsRate.replace(',','.')) : this.rate;
            }
        },
        checkMaxStg() {
            Object.entries(this.maxStgObject).forEach(([key, value]) => {
                if (key === this.$props.program) {
                    this.realtyPeriods.stgMax = value;
                }
            })
        },
        getFirstPayments() {
            const monthlyPaymentRate = +((this.rate / 12 / 100).toFixed(7));
            this.monthlyPay = (this.realty - this.pledge) * monthlyPaymentRate / (1-Math.pow(1 + monthlyPaymentRate, - (this.period - 1)));
            this.loanAmount = this.$props.program !== 'product_refinancing' ? Math.round(this.realty - this.pledge) : this.remainingDebt;
            this.income = Math.round(this.monthlyPay / 0.6);
            if (this.program === 'product_refinancing') this.getRemainingDebtPercent()
        },
        getRateRange() {
            this.$props.ranges.forEach((el) => {
                if (this.targetProgram === el.code) {
                    return this.range = el.range;
                }
            })
        },
        getTags() {
            this.tags = this.$props.calculatorPrograms.map(val => {
                return this.programs.filter(value => value.code === val)[0];
            });
        },
        initSliders() {
           this.loanSlider = noUiSlider.create(this.$refs.mortgagePrice, {
                    start: [this.realty],
                    connect: 'lower',
                    step: 1,
                    initial: this.realty,
                    range: {
                        'min': this.realtyPeriods.stgMin,
                        'max': this.realtyPeriods.stgMax
                    },
                    format: {
                        to: (value) => {
                            return value + ',-';
                        },
                        from: (value) => {
                            return Number(value.replace(',-', ''));
                        }
                    }
                })

                this.loanSlider.on('change', (val) => {
                    val = Number(val[0].replace(',-',''));
                    this.realty = Math.floor(val / 1000) * 1000;
                    this.$nextTick(() => {
                        this.getCalculationsFunctions();
                    })
                })

                this.loanSlider.on('update', (val) => {
                    val = Number(val[0].replace(',-',''));
                    this.realty = Math.round(val);
                })

                this.loanSlider.on('blur', () => {
                    this.getApixResults();
                })

                this.$refs.realtyInput.addEventListener('change', () => {
                    this.realty = Number(this.realty.replace(/\s/g, ''));
                    if (this.realty > this.realtyPeriods.stgMax) {
                        this.realty = this.realtyPeriods.stgMax;
                    }
                    else if (this.realty < this.realtyPeriods.stgMin) {
                        this.realty = this.realtyPeriods.stgMin;
                    }
                    this.loanSlider.set(this.realty);
                })

                this.$refs.realtyInput.addEventListener('blur', () => {
                    this.getCalculationsFunctions();
                })

                this.$refs.realtyInput.addEventListener('change', (val) => {
                    this.$refs.realtyInput.value = this.filters.formatWithDelimeters(val.target.value);
                })

                this.$refs.realtyInput.addEventListener('click', () => {
                    this.$refs.realtyInput.value = '';
                })

                if (this.$props.program !== 'product_refinancing') {
                    this.pledgeSlider = noUiSlider.create(this.$refs.pledge, {
                        start: [this.pledge],
                        connect: 'lower',
                        step: 1,
                        initial: this.pledge,
                        range: {
                            'min': this.pledgePeriods.pledgeMin,
                            'max': this.pledgePeriods.pledgeMax
                        },
                        format: {
                            to: (value) => {
                                return value + ',-';
                            },
                            from: (value) => {
                                return Number(value.replace(',-', ''));
                            }
                        }
                    })

                    this.pledgeSlider.on('change', (val) => {
                        val = Number(val[0].replace(',-',''));
                        this.pledge = Math.floor(val / 1000) * 1000;
                        if (this.pledge < this.pledgePeriods.pledgeMin) {
                            this.pledge = this.pledgePeriods.pledgeMin;
                        }
                        this.$nextTick(() => {
                            this.getCalculationsFunctions();
                        })
                    })

                    this.pledgeSlider.on('update', (val) => {
                        val = Number(val[0].replace(',-',''));
                        this.pledge = Math.round(val);
                    })

                    this.pledgeSlider.on('blur', () => {
                        this.getApixResults();
                    })

                    this.$refs.pledgeInput.addEventListener('change', () => {
                        this.pledge = Number(this.pledge.replace(/\s/g, ''));
                        if (this.pledge > this.pledgePeriods.pledgeMax) {
                            this.pledge = this.pledgePeriods.pledgeMax;
                        }
                        else if (this.pledge < this.pledgePeriods.pledgeMin) {
                            this.pledge = this.pledgePeriods.pledgeMin;
                        }
                        this.pledgeSlider.set(this.pledge);
                    })

                    this.$refs.pledgeInput.addEventListener('click', () => {
                        this.$refs.pledgeInput.value = '';
                    })

                    this.$refs.pledgeInput.addEventListener('change', (val) => {
                        this.$refs.pledgeInput.value = this.filters.formatWithDelimeters(val.target.value);
                    })

                    this.$refs.pledgeInput.addEventListener('blur', () => {
                        this.$nextTick(() => {
                            this.getCalculationsFunctions();
                        });
                    })
                }
                else {
                    this.remainingDebtSlider = noUiSlider.create(this.$refs.remaining, {
                        start: [this.remainingDebt],
                        connect: 'lower',
                        step: 1,
                        initial: this.remainingDebt,
                        range: {
                            'min': this.remainingDebtPeriods.remainingMin,
                            'max': this.remainingDebtPeriods.remainingMax
                        },
                        format: {
                            to: (value) => {
                                return value + ',-';
                            },
                            from: (value) => {
                                return Number(value.replace(',-', ''));
                            }
                        }
                    })

                    this.remainingDebtSlider.on('change', (val) => {
                        val = Number(val[0].replace(',-',''));
                        this.remainingDebt = Math.floor(val / 1000) * 1000;
                        this.getApixResults();
                        this.getRemainingDebtPercent();
                        this.$nextTick(() => {
                            this.getCalculationsFunctions();
                        })
                    })

                    this.remainingDebtSlider.on('update', (val) => {
                        val = Number(val[0].replace(',-',''));
                        this.remainingDebt = Math.round(val);
                    })

                    this.remainingDebtSlider.on('blur', () => {
                        this.getApixResults();
                    })

                    this.$refs.remainingInput.addEventListener('change', () => {
                        this.remainingDebt = Number(this.remainingDebt.replace(/\s/g, ''));
                        if (this.remainingDebt > this.remainingDebtPeriods.remainingMax) {
                            this.remainingDebt = this.remainingDebtPeriods.remainingMax;
                        }
                        else if (this.remainingDebt < this.remainingDebtPeriods.remainingMin) {
                            this.remainingDebt = this.remainingDebtPeriods.remainingMin;
                        }
                        this.remainingDebtSlider.set(this.remainingDebt);
                    })

                    this.$refs.remainingInput.addEventListener('click', () => {
                        this.$refs.remainingInput.value = '';
                    })

                    this.$refs.remainingInput.addEventListener('change', (val) => {
                        this.$refs.remainingInput.value = this.filters.formatWithDelimeters(val.target.value);
                    })

                    this.$refs.remainingInput.addEventListener('blur', () => {
                        this.$nextTick(() => {
                            this.getApixResults();
                            this.getRemainingDebtPercent();
                            this.getCalculationsFunctions();
                        });
                    })
                }

                this.periodSlider = noUiSlider.create(this.$refs.period, {
                    start: [this.period],
                    connect: 'lower',
                    step: 1,
                    range: {
                        'min': this.periods.periodMin,
                        'max': this.periods.periodMax,
                    },
                    format: {
                        to: (value) => {
                            return value + ',-';
                        },
                        from: (value) => {
                            return Number(value.replace(',-', ''));
                        }
                    }
                });

                this.periodSlider.on('change', (val) => {
                    val = Math.round(Number(val[0].replace(',-','')));
                    this.period = val;
                    this.getApixResults();
                });

                this.periodSlider.on('update', (val) => {
                    val = Math.round(Number(val[0].replace(',-','')));
                    this.period = Math.floor(val);
                })

                this.$refs.periodInput.addEventListener('change', () => {
                    this.getCalculationsFunctions();
                    this.periodSlider.set(this.period);
                });

                this.$refs.periodInput.addEventListener('click', () => {
                    this.$refs.periodInput.value = '';
                })

                this.$refs.periodInput.addEventListener('blur', () => {
                    this.$refs.periodInput.value = this.period;
                    this.getApixResults();
                })
        }
    },
    beforeMount() {
        if (this.$props.showCalculator === 'hide') return;

        let url = `/rest/v1/mortgage/products?sort=code&where[code]=${this.$props.program}`;

        if (!this.$props.program) {
            this.getTags();
            url = `/rest/v1/mortgage/products?sort=code&where[code]=${this.$props.calculatorPrograms.join(',')}`;
        }

        axios.get(url, {headers: {'Accept': 'application/vnd.api+json'}})
            .then((response) => {
                if (response.status !== 200) {
                    this.calculatorError = true;
                }
                else {
                    this.apix = response.data.data;
                    this.product = this.$props.program ? response.data.data.filter(val => val.id === this.$props.program) : response.data.data.filter(val => val.id === this.$props.calculatorPrograms[0]);
                    this.targetName = this.product[0].attributes.name;
                    this.targetProgram = this.product[0].id;
                    if (!this.$props.program) this.getTargetText()
                    this.maxCreditAmount = this.product[0].attributes.product.maxCreditAmount[0].maxCreditAmount;
                    this.getCalculationsFunctions();
                    this.getFirstPayments();
                    this.taxDeductionCalculate();
                    this.getRateRange();
                }
            })
            .catch(() => {
                this.calculatorError = true;
            })
            .finally(() => {
                this.calculatorReady = true;
                this.calculatorPending = false;
            })
    },
    watch: {
        realty(val) {
            this.sliderDisabledPrv = val === this.realtyPeriods.stgMin ? true : false;
        }
    },
    computed: {
        years() {
            if (this.period % 12 === 0) {
                return this.filters.periodString(this.period / 12);
            }
            else {
                return `${this.filters.periodString(Math.floor(this.period / 12))} ${this.$options.filters.months(this.period % 12)}`
            }
        }
    },
    mounted() {
        if (this.$props.showCalculator === 'hide') return;

        this.checkMaxStg();
        this.initSliders();
        this.realtyPeriods.stgMiddle = this.realtyPeriods.stgMax / 2;
        this.singleProgram = this.$props.program.length ? true : false;
    }
}
</script>

<style lang="scss">
    @import '../../assets/scss/block/mortgage-calculator-new.scss';
</style>
